import React, { useState, useEffect } from "react";
import { useDispatch } from "redux-react-hook";
import {
  Modal,
  Button,
  Form,
  FormGroup,
  FormSelectOption,
  FormSelect,
} from "@patternfly/react-core";

import { REQUESTED_UPDATE_VERSION } from "../../redux/actions/versionAction";
import versionCategoryConst from "../../constants/versionCategoryConst";

export default (props) => {
  const { isModalOpen, handleModalToggle } = props;
  const [version, setVersion] = useState(null);
  const [isConfirmButtonDisabled, setIsConfirmButtonDisabled] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.version) {
      setVersion({
        id: props.version.id,
        type: props.version.type,
      });
    }
  }, [props]);

  function onChange(value, event) {
    setIsConfirmButtonDisabled(value === props.version.type);
    const newVersion = { ...version, type: value };
    setVersion(newVersion);
  }

  function onConfirm() {
    dispatch({
      type: REQUESTED_UPDATE_VERSION,
      payload: { version },
    });
    handleModalToggle();
  }

  return (
    <Modal
      style={{ minHeight: "150px" }}
      width={"50%"}
      title="Version Category Setting"
      isOpen={isModalOpen}
      onClose={handleModalToggle}
      actions={[
        <Button
          isDisabled={isConfirmButtonDisabled}
          key="Confirm"
          variant="primary"
          onClick={onConfirm}
        >
          Confirm
        </Button>,
        <Button key="Cancel" variant="secondary" onClick={handleModalToggle}>
          Cancel
        </Button>,
      ]}
    >
      <Form isHorizontal>
        <FormGroup
          label="Version category:"
          fieldId="horizontal-form-version-category"
        >
          <FormSelect
            value={version && version.type}
            onChange={onChange}
            id="horzontal-form-version-category"
            name="horizontal-form-version-category"
          >
            {versionCategoryConst.versionCategoryOptions.map(
              (option, index) => (
                <FormSelectOption
                  isDisabled={option.disabled}
                  key={index}
                  value={option.value}
                  label={option.label}
                />
              )
            )}
          </FormSelect>
        </FormGroup>
      </Form>
      <hr style={{ marginTop: "1.5em", marginBottom: "1.5em" }} />
    </Modal>
  );
};
